export type LambdaType = string;

export enum BuiltInLambdaType {
    Expression = 'Expression',
    MessageOutput = 'MessageOutput',
    Edge = 'Edge',
    EnterWorkflow = 'EnterWorkflow',
    ExitWorkflow = 'ExitWorkflow',
    Join = 'Join',
    SerializePayload = 'SerializePayload',
    DeserializePayload = 'DeserializePayload',
    Inline = 'Inline'
}

export const isBuiltInLambda = (lambdaType: LambdaType): boolean => {
    return !!BuiltInLambdaType[lambdaType];
};

export const executeOnStopWorkflow = (lambdaType: LambdaType): boolean => {
    return (isBuiltInLambda(lambdaType) && lambdaType != BuiltInLambdaType.Inline) || lambdaType == matchmakerType;
};

export const matchmakerType = 'Matchmaker';
export const gatewayType = 'Gateway';
